<template>
  <div class="sop-manual-container">
    <div class="sop-header">
      <button class="btn btn-light btn-sm" @click="goBack">
        <i class="fas fa-arrow-left"></i> 뒤로가기
      </button>
      <!-- <h4 class="mb-0">운영 매뉴얼</h4> -->
      <div></div>
    </div>
    <div class="iframe-wrapper">
      <iframe
        v-if="!iframeError"
        :src="sopUrl"
        frameborder="0"
        @error="handleIframeError"
      ></iframe>
      <div v-if="iframeError" class="error-message">
        <i class="fas fa-exclamation-triangle"></i>
        <p>페이지를 불러올 수 없습니다.</p>
        <button class="btn btn-primary" @click="openInNewWindow">새 창으로 열기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SopManual',
  data() {
    return {
      sopUrl: 'https://sop.tfarmon.com/',
      iframeError: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleIframeError() {
      this.iframeError = true;
    },
    openInNewWindow() {
      window.open(this.sopUrl, '_blank');
    }
  }
};
</script>

<style scoped>
.sop-manual-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: white;
  z-index: 1000;
}

.sop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e4e6ef;
  background: white;
}

.iframe-wrapper {
  flex: 1;
  position: relative;
  overflow: hidden;
}

iframe {
  width: 100%;
  height: 100%;
}

.error-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #7e8299;
}

.error-message i {
  font-size: 48px;
  margin-bottom: 1rem;
  color: #f1416c;
}

.error-message p {
  font-size: 16px;
  margin-bottom: 1rem;
}
</style>
